export default "__VITE_ASSET__UFu4MrGl__"